import { Link } from 'react-router-dom'
import Logo from "../../images/logo.svg"
import Services from '../../api/Services';



const ClickHandler = () => {
    window.scrollTo({top:0,behavior:"smooth"});
}


const Footer = (props) => {


    return (
        <footer className="wpo-site-footer">
            <div className="wpo-top-footer">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                            <div className="widget">
                                <div className="logo">
                                    <Link className="navbar-brand" to="/home">
                                        <img src={Logo} alt="" width="200px" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                            <div className="widget">
                                <div className="social">
                                    <ul>
                                        <li>
                                            <a href="https://www.facebook.com/share/1EuHdLvyC5/?mibextid=wwXIfr">
                                                <i className="fa-brands fa-facebook"></i>
                                            </a>
                                        </li>
                                        
                                        <li>
                                            <a href="https://www.linkedin.com/company/heart-to-heart-children-aid/">
                                                <i className="fa-brands fa-linkedin"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.instagram.com/heart_to_heart_children_aid?igsh=MWM0NmtpcmQ1MDZiMg%3D%3D&utm_source=qr">
                                                <i className="fa-brands fa-instagram"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.tiktok.com/@heart_to_heart_aid?_r=1&_t=ZM-926DGZablCm">
                                                <i class="fa-brands fa-tiktok"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-5 col-md-6 col-12 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="widget-title">
                                    <h3>About Us</h3>
                                </div>
                                <p>Heart-to-Heart Children Aid was founded out of a deep belief that every heartbeat matters. We are a committed humanitarian organization providing free heart surgeries for children who cannot afford life-saving care. </p>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-12 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Quick Links</h3>
                                </div>
                                <ul>
                                    <li><Link to="/home" onClick={ClickHandler}>Home</Link></li>
                                    <li><Link to="/about" onClick={ClickHandler}>About Us</Link></li>
                                    <li><Link to="/impact" onClick={ClickHandler}>Our Impact</Link></li>
                                    <li><Link to="/donate" onClick={ClickHandler}>Donate</Link></li>
                                    <li><Link to="/gallery" onClick={ClickHandler}>Gallery</Link></li>
                                </ul>
                            </div>
                        </div>
                        {/* <div className="col col-lg-3 col-md-6 col-12 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget s2">
                                <div className="widget-title">
                                    <h3>Mission & Vision</h3>
                                </div>
                                <ul>
                                    {Services.map((service, sky) => (
                                        <li key={sky}><Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>{service.title}</Link></li>
                                    ))}
                                </ul>
                            </div>
                        </div> */}
                        <div className="col col-lg-3 col-md-6 col-12 col-md-6 col-sm-12 col-12">
                            <div className="widget newsletter-widget">
                                <div className="widget-title">
                                    <h3>Contact Us</h3>
                                </div>
                                <p>Have any question contact us. </p>
                                <ul className="info">
                                    <li><i className="flaticon-email"></i> info@hearttoheartchildrensaid.org</li>
                                    <li><i className="flaticon-telephone"></i>+1 202 594 4021</li>
                                    <li><i className="flaticon-telephone"></i>+251 99 077 7776</li>
                                    <li><i className="flaticon-location"></i>Washington DC , USA</li>
                                    <li><i className="flaticon-location"></i>Addis Ababa , Ethiopia</li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col col-lg-12 col-md-12 col-12">
                            <ul>
                                <li>  &copy; {new Date().getFullYear()}{" "}
                               Heart to Heart Children's Aid. All rights reserved | Developed by <a href="https://revosolutionplc.com/">Revo Solutions PLC</a></li>
                            </ul>
                        </div>
                        <div className="col col-lg-6 col-md-12 col-12">
                            {/* <div className="link">
                                <ul>
                                    <li><Link to="/">Privace & Policy</Link></li>
                                    <li><Link to="/">Terms</Link></li>
                                    <li><Link to="about">About us</Link></li>
                                    <li><Link to="faq">FAQ</Link></li>
                                    <li><Link to="volunteer">Volunteer</Link></li>
                                </ul>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;




